import { Grid, Typography } from '@mui/material';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { SarlaftVinculationExistProps } from './props';
import { useSarlaftVinculationExist } from './hook';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftVinculationExist = (
    props: SarlaftVinculationExistProps
) => {
    const {
        formik,
        policiesInsureds,
        policiesBeneficiaries,
        insuredsBeneficiaries,
    } = useSarlaftVinculationExist(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Vinculos existentes
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(policiesInsureds)}
                    label="Tomador - Asegurado"
                    name="policyHolderInsured"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.policyHolderInsured}
                    errors={formik.errors.policyHolderInsured}
                    value={formik.values.policyHolderInsured}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('policyHolderInsured', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(policiesBeneficiaries)}
                    label="Tomador - Beneficiario"
                    name="policyHolderBeneficiary"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.policyHolderBeneficiary}
                    errors={formik.errors.policyHolderBeneficiary}
                    value={formik.values.policyHolderBeneficiary}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('policyHolderBeneficiary', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(insuredsBeneficiaries)}
                    label="Asegurado - Beneficiario"
                    name="insuredBeneficiary"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.insuredBeneficiary}
                    errors={formik.errors.insuredBeneficiary}
                    value={formik.values.insuredBeneficiary}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('insuredBeneficiary', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
